import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SSOCallbackComponent } from './sso-callback/sso-callback.component';
import { ErrorFallbackComponent } from './error-fallback/error-fallback.component';
import { RouterModule } from '@angular/router';
import { heroEye, heroEyeSlash, heroXCircle, heroShieldExclamation, heroWifi, heroLockClosed, heroMagnifyingGlass, heroExclamationTriangle, heroExclamationCircle, heroArrowPath, heroArrowLeft, heroHome } from '@ng-icons/heroicons/outline';
import { bootstrapMicrosoft } from '@ng-icons/bootstrap-icons';
import { NgIconsModule, provideNgIconsConfig } from '@ng-icons/core';
import { MaterialModule } from '../app-material/material/material.module';
import { ChangePasswordComponent } from './change-password/change-password.component';

@NgModule({
  declarations: [LoginComponent, ForgotPasswordComponent, ChangePasswordComponent, SSOCallbackComponent, ErrorFallbackComponent],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    NgIconsModule.withIcons({ 
      heroEye, 
      heroEyeSlash, 
      microsoft: bootstrapMicrosoft,
      heroXCircle,
      heroShieldExclamation,
      heroWifi,
      heroLockClosed,
      heroMagnifyingGlass,
      heroExclamationTriangle,
      heroExclamationCircle,
      heroArrowPath,
      heroArrowLeft,
      heroHome
    }),
  ],
  providers: [provideNgIconsConfig({
    size: '1.5rem',
  })],
  exports: [
    LoginComponent, ForgotPasswordComponent, ChangePasswordComponent, SSOCallbackComponent, ErrorFallbackComponent
  ]
})
export class AuthModule { }
